import React, {Component} from 'react';
import {Grid}             from 'semantic-ui-react';
import {
  Route,
  Switch,
}                         from 'react-router-dom';
import {withRouter}       from 'react-router';
import PropTypes          from 'prop-types';

import MainGaelle         from '../MainGaelle';
import MainAdmin          from '../MainAdmin';
import MainAdminWYSIWYG   from '../MainAdminWYSIWYG';
import MainPrice          from '../MainPrice';
import MainMusicTherapy   from '../MainMusicTherapy';
import MainShop           from '../MainShop';
import MainGbAcademy      from '../MainGbAcademy';
// import MainAbout          from '../MainAbout';
import MainsAbout         from '../MainsAbout';
import MainContact        from '../MainContact';
import MainSingingLesson  from '../MainSingingLesson';
import MainMusicAwareness from '../MainMusicAwareness';
import MainCalendar       from '../MainCalendar';
import MainShow           from '../MainShow';
import MainChoir          from '../MainChoir';
import MainReview         from '../MainReview';
import classnames         from 'classnames';
import {
  TransitionGroup,
  CSSTransition,
}                         from 'react-transition-group';

// Molecule
import ScrollArea         from '../../molecules/ScrollArea';
// Style
import                    './MainHome.scss';

const propTypes = {
  location: PropTypes.shape(
    {
      pathname : PropTypes.string,
      key      : PropTypes.string,
    }
  ).isRequired,
};

const defaultProps = {};

class MainHome extends Component {

  render() {
    const {location: {pathname}} = this.props;

    let addClass;
    switch (pathname) {

      case '/about': {
        addClass = 'partition';
        break;
      }

      case '/contact': {
        addClass = 'contact';
        break;
      }

      case '/lesson': {
        addClass = 'lesson';
        break;
      }

      case '/music-awareness': {
        addClass = 'musicawareness';
        break;
      }

      case '/music-choir': {
        addClass = 'choir';
        break;
      }

      case '/music-show': {
        addClass = 'musicshow';
        break;
      }

      case '/music-therapy': {
        addClass = 'musictherapy';
        break;
      }

      case '/shop': {
        addClass = 'shop';
        break;
      }

    }

    return (
      <React.Fragment>
        {pathname === '/gaelle'
          ? <MainAdmin />
          : pathname === '/admin'
            ? <MainAdminWYSIWYG />
            : (
              <React.Fragment>
                <Grid
                  className='sgr-mainHome-static'
                >
                  <Grid.Column
                    className={classnames(
                      'sgr-mainHome-grid-one',
                      addClass
                    )}
                    width={6}
                  />
                  <Grid.Column
                    className={classnames(
                      'sgr-mainHome-grid-two',
                      addClass
                    )}
                    width={10}
                  />
                </Grid>

                <ScrollArea addClass={addClass}>
                  <Grid
                    className='sgr-mainHome-grid'
                  >
                    <Grid.Column width={6} />

                    <Grid.Column
                      className='sgr-mainHome-grid-two'
                      width={10}
                    >
                      <div className='page'>
                        <TransitionGroup>
                          <CSSTransition
                            classNames='SlideIn'
                            key={this.props.location.key}
                            mountOnEnter
                            timeout={600}
                            unmountOnExit
                          >
                            <Switch location={this.props.location}>
                              <Route
                                component={MainGaelle}
                                exact
                                path='/'
                              />
                              <Route
                                component={MainShow}
                                exact
                                path='/music-show'
                              />
                              <Route
                                component={MainSingingLesson}
                                exact
                                path='/lesson'
                              />
                              <Route
                                component={MainChoir}
                                exact
                                path='/music-choir'
                              />
                              <Route
                                component={MainPrice}
                                exact
                                path='/price'
                              />
                              <Route
                                component={MainMusicTherapy}
                                exact
                                path='/music-therapy'
                              />
                              <Route
                                component={MainReview}
                                exact
                                path='/review'
                              />
                              <Route
                                component={MainMusicAwareness}
                                exact
                                path='/music-awareness'
                              />
                              <Route
                                component={MainsAbout}
                                exact
                                path='/about'
                              />
                              <Route
                                component={MainContact}
                                exact
                                path='/contact'
                              />

                              <Route
                                component={MainShop}
                                exact
                                path='/shop'
                              />

                              <Route
                                component={MainGbAcademy}
                                exact
                                path='/gbacademy'
                              />

                              <Route
                                component={MainCalendar}
                                exact
                                path='/calendar'
                              />
                            </Switch>
                          </CSSTransition>
                        </TransitionGroup>
                      </div>
                    </Grid.Column>
                  </Grid>
                </ScrollArea>
              </React.Fragment>
            )
        }
      </React.Fragment>
    );
  }

}

MainHome.propTypes = propTypes;
MainHome.defaultProps = defaultProps;

export const MainHomeTest = MainHome;

export default withRouter(MainHome);



// WEBPACK FOOTER //
// ./src/organisms/MainHome/MainHome.js